import React from "react";
import { createPortal } from "react-dom";
import { Box, Typography } from "@mui/material";
import { cutCorner, ga } from "../../../components/ui/GaPrimitives";
import { EggAnimation } from "./EggAnimation";

export function AnswerResultFrame({
  open,
  onClose,
  accent,
  accentColor,
  rest,
  body,
  reward,
  rewardColor,
  cta,
  fadedEgg = false,
}) {
  if (!open) return null;

  return createPortal(
    <Box
      onClick={(event) => event.stopPropagation()}
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 4000,
        bgcolor: "rgba(0,0,0,0.88)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 340,
          bgcolor: "#151A0E",
          border: `1px solid ${ga.border}`,
          clipPath: cutCorner(18),
          px: 2.75,
          pt: 1.5,
          pb: 2.5,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <EggAnimation faded={fadedEgg} />
        <Box
          sx={{
            display: "flex",
            alignItems: "baseline",
            justifyContent: "center",
            gap: "8px",
            mb: 1.25,
          }}
        >
          <Typography
            sx={{
              fontFamily: "'Rajdhani', sans-serif",
              fontWeight: 700,
              fontSize: 22,
              letterSpacing: "1.2px",
              color: accentColor,
              lineHeight: 1,
            }}
          >
            {accent}
          </Typography>
          <Typography
            sx={{
              fontFamily: "'Rajdhani', sans-serif",
              fontWeight: 700,
              fontSize: 22,
              letterSpacing: "1.2px",
              color: ga.white,
              lineHeight: 1,
            }}
          >
            {rest}
          </Typography>
        </Box>
        <Typography
          sx={{
            fontFamily: "'Poppins', sans-serif",
            fontWeight: 500,
            fontSize: 13.5,
            lineHeight: "20px",
            color: "#F4F7EE",
            maxWidth: 250,
            mb: reward ? 0 : 2.75,
          }}
        >
          {body}
        </Typography>
        {reward ? (
          <Typography
            sx={{
              fontFamily: "'Rajdhani', sans-serif",
              fontWeight: 700,
              fontSize: 14,
              letterSpacing: "0.6px",
              color: rewardColor,
              mt: 1.25,
              mb: 2.75,
            }}
          >
            {reward}
          </Typography>
        ) : null}
        <Box
          component="button"
          type="button"
          onClick={onClose}
          sx={{
            width: "100%",
            height: 48,
            border: 0,
            bgcolor: ga.lime,
            color: ga.bg,
            fontFamily: "'Rajdhani', sans-serif",
            fontWeight: 700,
            fontSize: 15,
            letterSpacing: "1.6px",
            textTransform: "uppercase",
            clipPath: cutCorner(10),
            cursor: "pointer",
            outline: "none",
            WebkitTapHighlightColor: "transparent",
            "&:focus, &:focus-visible, &:active": {
              outline: "none",
            },
          }}
        >
          {cta}
        </Box>
      </Box>
    </Box>,
    document.body
  );
}
